import { InboxModulePathType } from "@saysimple-platform/dtos";

export default [
    {
        title: `mainmenu.${InboxModulePathType.MESSAGING}`,
        route: InboxModulePathType.MESSAGING,
        icon: "comment-dots",
        resource: "inbox",
        action: "read",
    },
];
